import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { PaginationVM, DOTS } from './PaginationVM';
import Icon from '@mdi/react';
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';
import './Pagination.scss';

const PaginationComponent = (props) => {
  const { onPageChange, totalCount, siblingCount, currentPage, pageSize, className } = props;
  const vm = useRef(new PaginationVM(props)).current;

  useEffect(() => {
    vm.lastPage = Math.ceil(totalCount / pageSize);
    vm.usePagination({ currentPage, totalCount, siblingCount, pageSize });
  }, [totalCount, pageSize, currentPage]);

  // If there are less than 2 times in pagination range we shall not render the component
  return currentPage === 0 || vm.paginationRange.length < 2 ? null : (
    <div className={`pagination-container ${className}`}>
      {/* Left navigation arrow */}
      <button
        data-testid="previous"
        key="previous"
        className={`pagination-item arrow${currentPage === 1 ? ' disabled' : ''}`}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <Icon path={mdiChevronLeft} title="" size={0.5} />
        Prev
      </button>

      {vm.paginationRange.map((pageNumber, i) => {
        // If the pageItem is a DOT, render the DOTS unicode character
        if (pageNumber === DOTS) {
          return (
            <button key={`${pageNumber}-${i}`} className="pagination-item dots no-border">
              &#8230;
            </button>
          );
        }

        // Render our Page Pills
        return (
          <button
            key={`${pageNumber}-${i}`}
            className={`pagination-item usa-button${pageNumber !== currentPage ? ' usa-button--outline' : ''}`}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </button>
        );
      })}

      {/*  Right Navigation arrow */}
      <button
        data-testid="next"
        key="next"
        className={`pagination-item arrow${currentPage === vm.lastPage ? ' disabled' : ''}`}
        onClick={() => onPageChange(currentPage + 1)}
      >
        Next
        <Icon path={mdiChevronRight} title="" size={0.5} />
      </button>
    </div>
  );
};

export const Pagination = observer(PaginationComponent);
